module.exports = __webpack_public_path__ + "img/Corporations.55b6ae71.png";